/* eslint-disable */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Select from 'react-select-legacy';

import AppLink from 'components/AppLink';

import styles from './styles.styl';

class OptionComponent extends PureComponent {
  handleMouseDown = event => {
    event.preventDefault();
    event.stopPropagation();
    if (this.props.option.disabled) return;
    this.props.onSelect(this.props.option, event);
  };

  handleMouseEnter = event => {
    this.props.onFocus(this.props.option, event);
  };

  handleMouseMove = event => {
    if (this.props.isFocused) return;
    this.props.onFocus(this.props.option, event);
  };

  render() {
    return this.props.option.slug || this.props.option.slug === '' ? (
      <AppLink
        className={this.props.className}
        href={`/articles/category?slug=${this.props.option.slug}`}
        as={`/articles/${this.props.option.slug}${window.location.search}`}
      >
        {this.props.children}
      </AppLink>
    ) : (
      <div
        className={this.props.className}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        title={this.props.option.label}
      >
        {this.props.children}
      </div>
    );
  }
}

const ValueComponent = props => <div className={styles.SelectField__value}>{props.children}</div>;

class SelectField extends PureComponent {
  static defaultProps = {
    className: '',
    isSearchable: false,
    noResultsText: '',
    theme: 'default',
  };

  static propTypes = {
    className: PropTypes.string,
    name: PropTypes.string,
    labelKey: PropTypes.string,
    valueKey: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    options: PropTypes.array,
    isSearchable: PropTypes.bool,
    noResultsText: PropTypes.string,
    theme: PropTypes.oneOf(['default', 'withBorder', 'inArticles']),
  };

  state = {
    focus: false,
    value: '',
  };

  onChange = ({ value, disabled }) => {
    if (disabled) return;
    this.setState({ value });
    this.props.onChange && this.props.onChange(value);
  };

  onFocus = e => {
    this.setState({ focus: true }, () => this.props.onFocus && this.props.onFocus(e));
  };

  onBlur = e => {
    this.setState({ focus: false }, this.props.onBlur && this.props.onBlur(e));
  };

  render() {
    const {
      className,
      theme,
      labelKey = 'label',
      valueKey = 'value',
      value,
      name,
      meta,
      isSearchable,
      noResultsText,
      options,
      disabled,
      ...otherProps
    } = this.props;

    const style = cn(styles.SelectField, className, {
      [styles.SelectField_focused]: this.state.focus,
      [styles.SelectField_value]: value,
      [styles.SelectField_error]: meta && meta.touched && meta.error,
      [styles.SelectField_valid]: meta && meta.touched && meta.valid,
      [styles.SelectField_disabled]: disabled,
      [styles[`SelectField_${theme}`]]: !!theme,
    });

    return (
      <div className={style}>
        <label>
          <Select
            {...otherProps}
            name={name}
            instanceId={name}
            value={value || this.state.value}
            labelKey={labelKey}
            valueKey={valueKey}
            optionClassName={styles.SelectField__option}
            optionComponent={OptionComponent}
            valueComponent={ValueComponent}
            options={options}
            onChange={this.onChange}
            onBlur={this.onBlur}
            onFocus={this.onFocus}
            autoBlur={true}
            removeSelected={false}
            noResultsText={noResultsText || false}
            disabled={disabled}
            searchable={isSearchable}
          />
        </label>
      </div>
    );
  }
}

export default SelectField;
